import React, { useState, useEffect } from "react";
import { Modal } from "react-responsive-modal";
import * as moment from "moment";
import Button from "components/CustomButton";
import Loader from "components/Loader";
import TeamService from "services/TeamService";
import Avatar from "components/Avatar";
import { useUserContext } from "store/contexts/userContext";
import { useHistory } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import Scrollbar from "react-scrollbars-custom";
import PublishPost from "./PublishPost";
import { useGlobalContext } from "store/contexts/globalContext";

var styles = {
  loader: {
    display: "flex",
    justifyContent: "center",
  },
  image: {
    width: "100%",
    background: "rgb(204, 204, 204)",
    height: "300px",
    objectFit: "contain",
  },
  responseContainer: {
    display: "flex",
    minHeight: "50px",
    alignItems: "center",
    boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
    border: "none",
    borderRadius: "5px",
  },
  detailsSection: {
    flex: "1",
    display: "flex",
    flexDirection: "column",
    fontSize: "12px",
    padding: "5px",
    lineHeight: "14px",
  },
  userName: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    width: "81px",
    fontSize: "13px",
    fontWeight: 500,
  },
  notRespond: {
    fontSize: "11px",
    fontWeight: 400,
    color: "red",
  },
  responseAwaits: {
    fontSize: "11px",
    fontWeight: 400,
    paddingTop: "2px",
  },
  remindButton: {
    background: "linear-gradient(to right, #FFA100 50%, #FFC42F, #FFE75E)",
    color: "black",
    fontSize: "12px",
    padding: "3px 11px",
    height: "unset",
  },
  heading: {
    background: "#2c3036",
    display: "flex",
    justifyContent: "center",
    color: "white",
    padding: " 10px",
    fontSize: "18px",
  },
  initiatedContent: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0.25rem 1rem",
  },
  leftInitiatedContent: {
    display: "flex",
    flexDirection: "column",
    padding: "5px 0",
  },
  initiatedText: {
    fontSize: "15px",
    fontWeight: 500,
  },
  dateText: {
    fontWeight: 300,
  },
  responsesListContainer: {
    display: "grid",
    gridGap: "1rem",
    gridAutoFlow: "dense",
    gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
    padding: "0.25rem 1rem 1rem",
  },
};

export default ({ post }) => {
  const classes = styles;
  let history = useHistory();
  const [dialogState, setDialogState] = useState(false);
  const [remindPerson, setRemindPerson] = useState();
  const [loading, setLoading] = useState(false);
  const [responsesData, setResponsesData] = useState(null);
  const [disableReminder, setDisableReminder] = useState(false);
  const { addToast } = useToasts();
  const [teamRole, setTeamRole] = useState();
  const { checkYourTeamRole } = useGlobalContext();
  const { user } = useUserContext();
  const [post_types] = useState({
    slideshow: "Slideshow",
    teamvideo: "TeamVideo",
  });

  const showUserProfile = (id) => {
    setDialogState(false);
    history.push(`/profile/${id}`);
  };

  useEffect(() => {
    // setLoading(true);

    if (!dialogState) {
      return;
    }

    (async () => {
      try {
        var response = await checkYourTeamRole(post.team_id);
        setTeamRole(response);
      } catch (e) {
        console.log(e);
      }
    })();

    (async () => {
      try {
        var response = null;
        if (post.type === "slideshow") {
          response = await TeamService.getSlideShowResponse(
            post?.team_id,
            post?.id
          );
        }

        if (post.type === "teamvideo") {
          response = await TeamService.getTeamVideoResponse(
            post?.team_id,
            post?.id
          );
        }
        var allMembers = await getYourTeamData(response.data.data);

        setResponsesData(allMembers);
        // setLoading(false);
      } catch (e) {
        console.error(e);
      }
    })();

    //eslint-disable-next-line
  }, [post, dialogState]);

  function getYourTeamData(teamMembers) {
    var allTeamMember = teamMembers?.members.sort(
      (a, b) => a.role_id - b.role_id
    );

    var userData = teamMembers?.members.filter((member) => {
      return member?.id === user.id;
    });

    let memberIndex = teamMembers?.members.indexOf(userData[0]);
    allTeamMember.splice(memberIndex, 1);
    allTeamMember.splice(0, 0, userData[0]);
    return allTeamMember;
  }

  const postRemind = async (user) => {
    try {
      if (post.type === "slideshow") {
        await TeamService.postRemindSlideshow(
          post?.team_id,
          post?.data?.id,
          user?.id
        );
      }

      if (post.type === "teamvideo") {
        await TeamService.postRemindTeamVideo(
          post?.team_id,
          post?.data?.id,
          user?.id
        );
      }

      setRemindPerson(user);
      addToast(`Reminder send successfully to ${user?.full_name}`, {
        appearance: "success",
      });
      setDisableReminder(true);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      {([2, 3].includes(teamRole) || post?.user?.id === user?.id) && (
        <span className="viewDetailButton">
          <span onClick={() => setDialogState(true)}>View Details</span>
        </span>
      )}
      <Modal
        classNames={{
          modalContainer: "modalContainer",
          modal: "postModal",
        }}
        open={dialogState}
        showCloseIcon={false}
        onClose={() => setDialogState(false)}
      >
        <div>
          <div style={classes.heading}>{post_types[post?.type] === "TeamVideo" ? "Team Video" : post_types[post?.type] }</div>
        </div>
        <div>
          <div>
            {post?.type === "teamvideo" && (
              <video
                style={classes.image}
                src={post?.data?.media}
                alt={post?.topic}
                autoPlay={false}
                preload="metadata"
                controls={false}
              ></video>
            )}
            {post?.type === "slideshow" && (
              <img
                src={post?.data?.media}
                style={classes.image}
                preload="metadata"
                alt={"img"}
              />
            )}
            <div style={classes.initiatedContent}>
              <div style={classes.leftInitiatedContent}>
                <span style={classes.initiatedText}>Initiated</span>
                <span style={classes.dateText}>
                  {moment(post?.created_at).format("DD MMMM YYYY LT")}
                </span>
              </div>
              <PublishPost
                post={post}
                setLoading={setLoading}
                loading={loading}
                post_types={post_types}
                setDialogState={setDialogState}
              />
            </div>
          </div>
          <div>
            <Scrollbar
              translateContentSizeYToHolder={true}
              style={{
                maxHeight: "calc(100vh - 485px)",
              }}
            >
              <div>
                <div style={classes.responsesListContainer}>
                  {!responsesData && (
                    <div style={classes.loader}>
                      <Loader />
                    </div>
                  )}
                  {responsesData &&
                    responsesData.map((response) => (
                      <div
                        key={response?.id}
                        elevation={3}
                        style={classes.responseContainer}
                      >
                        <Avatar
                          onClick={() => showUserProfile(response?.id)}
                          src={response?.avatar}
                          style={{
                            cursor: "pointer",
                            borderRadius: "50%",
                            height: "40px",
                            width: "40px",
                          }}
                        />
                        <div style={classes.detailsSection}>
                          <span style={classes.userName}>
                            {response?.id === user?.id
                              ? "You"
                              : response?.full_name}
                          </span>
                          {post.data.published && !response?.responded_at && (
                            <span style={classes.notRespond}>
                              Not Responded
                            </span>
                          )}
                          {!response?.responded_at && !post.data.published && (
                            <span style={classes.responseAwaits}>
                              Response Awaits
                            </span>
                          )}
                          <span
                            style={{
                              color: "green",
                              paddingop: "2px",
                              paddingBottom: "2px",
                            }}
                          >
                            {!!response?.responded_at && <b>Responded</b>}
                            {!response?.responded_at &&
                              !post.data.published &&
                              response?.id !== user?.id && (
                                <div style={{ paddingTop: "4px" }}>
                                  <Button
                                    disabled={
                                      remindPerson &&
                                      remindPerson?.id === response?.id &&
                                      disableReminder &&
                                      loading &&
                                      true
                                    }
                                    buttonClass={"grad_btn"}
                                    onClick={() => postRemind(response)}
                                    buttonStyle={classes.remindButton}
                                    size="sm"
                                  >
                                    Remind
                                  </Button>
                                </div>
                              )}
                          </span>
                          <span>
                            {!!response?.responded_at &&
                              moment(response?.responded_at).format(
                                "MMM DD, YYYY"
                              )}
                          </span>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </Scrollbar>
          </div>
        </div>
      </Modal>
    </>
  );
};
